import React, { useCallback, useMemo } from 'react';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { ModeSettingEnum } from '@colonist/types';
import { useHotkeys } from 'react-hotkeys-hook';
import { useIsDiceActive, useIsDiceVisible } from './utils.ts';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
import { UIGameDiceGroup } from './UIGameDiceGroup.tsx';
import { StorageWrapper } from '../../utils/storage.ts';
import { useCurrentStateValidator } from '../../store/selectors/useCurrentStateValidator.ts';
export function UIGameDiceGroupContainer({ playerColor, size = 'medium', className, disableDiceSound = false }) {
    const diceState = useGameStore((state)=>state.gameState.diceState);
    const eventDiceState = useGameStore((state)=>state.gameState.mechanicEventDiceState);
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const myColor = useGameStore((state)=>state.myColor);
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const currentStateValidator = useCurrentStateValidator();
    const visible = useIsDiceVisible(currentState, currentStateValidator.currentTurnPlayers, playerColor);
    var _currentStateValidator_currentTurnPlayers;
    const { active, helperText } = useIsDiceActive(currentState, playerColor, myColor, (_currentStateValidator_currentTurnPlayers = currentStateValidator.currentTurnPlayers) !== null && _currentStateValidator_currentTurnPlayers !== void 0 ? _currentStateValidator_currentTurnPlayers : []);
    const isBeginnerMode = modeSetting == ModeSettingEnum.BeginnerModeClassic4P;
    const beginnerHintType = useGameStore((state)=>state.gameBeginnerHint.beginnerHintType);
    const setBeginnerHintType = useGameStore((state)=>state.gameBeginnerHint.setBeginnerHintType);
    const { sendClickedDice, sendDiceNumberAnimationEnd } = useGameStore((state)=>state.gameSendEvent);
    const isPaused = useGameStore((state)=>state.gamePause.isPaused);
    const isReplay = useIsReplay();
    const isMyTurn = currentStateValidator.currentTurnPlayers.includes(myColor);
    const enableDiceHelper = isBeginnerMode;
    const disableDiceSoundLocal = disableDiceSound || isReplay;
    const isColonistRush = modeSetting == ModeSettingEnum.ColonistRush4P;
    const soundOnClick = useMemo(()=>{
        if (isColonistRush) return AudioType.Click // TODO add custom sound for Colonist Rush
        ;
        return AudioType.Click;
    }, [
        isColonistRush
    ]);
    const clearBeginnerHint = ()=>{
        if (beginnerHintType == 'RollDice') {
            setBeginnerHintType(undefined);
        }
    };
    const handleClick = useCallback(()=>{
        if (isPaused) return;
        if (isReplay) return;
        if (!isMyTurn) return;
        AudioManager.play(soundOnClick);
        if (active) {
            clearBeginnerHint();
            sendClickedDice();
        }
    }, [
        isPaused,
        isReplay,
        isMyTurn,
        active,
        soundOnClick
    ]);
    useHotkeys('Space', ()=>{
        if (StorageWrapper.getKeyboardShortcuts()) {
            handleClick();
        }
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ React.createElement(UIGameDiceGroup, {
        size: size,
        className: className,
        onClick: handleClick,
        diceState: diceState,
        eventDiceState: eventDiceState,
        active: active,
        visible: visible,
        enableDiceHelper: enableDiceHelper,
        helperText: helperText,
        isMyTurn: isMyTurn,
        disableDiceSound: disableDiceSoundLocal,
        onDiceHelperAnimationEnd: sendDiceNumberAnimationEnd
    });
}
